import { loanDetailsData } from "configs/loanDetails.config";
import { partnerData } from "configs/partners.config";
import { Dropdown, FilePicker, GroupRenderer, Input, Textarea } from "stories";
import { RadioGroupList } from "stories/components/radioGroup/RadioGroup";
import { ConditionalFormRenderer } from "../../../../../../../../../stories/components/FormRenderer/ConditionalFormRenderer";
import { getPartnerModel } from "../../../partners/Partners";
import { getPrincipalModel } from "../../../partners/principals/Principals";
import {
  completedProjectFields,
  currentProjectFields,
  numberValueTransformer,
} from "./corporationFields";

export const getEntityTypeDefaultValues = () => ({
  fullname: "",
  hq_address: "",
  identification: "",
  personal_net_worth: "",
  website: "",
  biography: "",
  address: "",
  net_worth_document_filename: null,
  corporation_name: "",
  industry: "",
  incorporation_document_filename: "",
  corporate_share_register_filename: "",
  corporate_net_asset_value: "",
  financial_statement_filename: "",
  principals: [getPrincipalModel()],
});

export const limitedLiabilityPartnershipFields = [
  [
    {
      name: "corporate_structure",
      component: Dropdown,
      props: {
        label: "Corporate Structure",
        list: loanDetailsData.corporationTypeList,
      },
    },
    {
      name: "name_of_partnership",
      component: Input,
      props: {
        label: "Name of Partnership",
      },
    },
    {
      name: "total_number_of_lp_units",
      component: Input,
      valueTransformer: numberValueTransformer,
      props: {
        label: "Total Number of LP Shares/Units",
        type: "number",
      },
    },
  ],
  [
    {
      name: "partners",
      renderAsFormItem: false,
      component: GroupRenderer,
      props: {
        title: "Partners",
        itemPrefix: "Partner",
        addButtonText: "Add One More Partner",
        fields: [
          [
            {
              name: "number_of_lp_units",
              component: Input,
              valueTransformer: numberValueTransformer,
              props: {
                label: "# of LP Units",
                type: "number",
              },
            },
            {},
          ],
          [
            {
              name: "guarantor_status",
              component: RadioGroupList,
              props: {
                label: "Guarantor Status",
                list: partnerData.guarantorStatus,
              },
            },
            {
              name: "entity_type",
              component: RadioGroupList,
              props: {
                label: "Entity Type",
                list: partnerData.partnerType,
              },
            },
            {},
          ],
          [
            {
              renderAsFormItem: false,
              component: ConditionalFormRenderer,
              props: {
                conditionFieldName: "entity_type",
                getDefaultValues: getEntityTypeDefaultValues,
                cacheable: true,
                conditionalFields: {
                  person: [
                    [
                      {
                        name: "fullname",
                        component: Input,
                        props: {
                          label: "Full Name",
                        },
                      },
                      {
                        name: "identification",
                        component: Input,
                        props: {
                          label: "Identification",
                        },
                      },
                    ],

                    [
                      {
                        name: "biography",
                        component: Textarea,
                        props: {
                          label: "Biography",
                        },
                      },
                    ],
                    [
                      {
                        name: "address",
                        component: Input,
                        props: {
                          label: "Address",
                        },
                      },
                    ],
                    [
                      {
                        name: "personal_net_worth",
                        component: Input,
                        props: {
                          label: "Personal Net-Worth",
                          type: "currency",
                          startAdornment: "$",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "net_worth_document_filename",
                        component: FilePicker,
                        props: {
                          label: "Net Worth Documentation",
                          type: "file",
                        },
                      },
                      {},
                    ],
                  ],
                  corporation: [
                    [
                      {
                        name: "corporation_name",
                        component: Input,
                        props: {
                          label: "Corporation Name",
                        },
                      },
                      {
                        name: "website",
                        component: Input,
                        props: {
                          label: "Website",
                        },
                      },
                      {
                        name: "industry",
                        component: Input,
                        props: {
                          label: "Industry",
                        },
                      },
                    ],
                    [
                      {
                        name: "incorporation_document_filename",
                        component: FilePicker,
                        props: {
                          label: "Incorporation Documents",
                          type: "file",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "corporate_share_register_filename",
                        component: FilePicker,
                        props: {
                          label: "Corporate Share Registrar",
                          type: "file",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "biography",
                        component: Textarea,
                        props: {
                          label: "Biography",
                        },
                      },
                    ],
                    [
                      {
                        name: "hq_address",
                        component: Input,
                        props: {
                          label: "HQ Address",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "corporate_net_asset_value",
                        component: Input,
                        props: {
                          label: "Corporate Net Asset Value",
                          type: "currency",
                          startAdornment: "$",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "financial_statement_filename",
                        component: FilePicker,
                        props: {
                          label: "Financial Statements",
                          type: "file",
                        },
                      },
                      {},
                    ],
                    [
                      {
                        name: "principals",
                        renderAsFormItem: false,
                        component: GroupRenderer,
                        props: {
                          title: "Principals",
                          itemPrefix: "Principal",
                          addButtonText: "Add More",
                          fields: [
                            [
                              {
                                name: "name",
                                component: Input,
                                props: {
                                  label: "Name",
                                },
                              },
                              {
                                name: "position",
                                component: Input,
                                props: {
                                  label: "Position",
                                },
                              },
                            ],
                            [
                              {
                                name: "share_of_corporation",
                                component: Input,
                                valueTransformer: numberValueTransformer,
                                props: {
                                  label: "% Ownership of Corporation",
                                  type: "number",
                                },
                              },
                              {},
                            ],
                            [
                              {
                                name: "notes",
                                component: Textarea,
                                props: {
                                  label: "Notes",
                                },
                              },
                            ],
                            [
                              {
                                name: "personal_net_worth",
                                component: Input,
                                props: {
                                  label: "Personal Net-Worth",
                                  type: "currency",
                                  startAdornment: "$",
                                },
                              },
                              {},
                            ],
                            [
                              {
                                name: "net_worth_document_filename",
                                component: FilePicker,
                                props: {
                                  label: "Net Worth Documentation",
                                  type: "file",
                                },
                              },
                              {},
                            ],
                          ],
                          getModelItem: getPrincipalModel,
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
        ],
        getModelItem: getPartnerModel,
      },
    },
  ],
  [completedProjectFields],
  [currentProjectFields],
];
